import { Operator } from '@jexop/core';
import { DateTime } from 'luxon';
import { generatePath } from 'react-router-dom';
import { Nullable } from '../types';

type Range = 'today' | 'yesterday' | 'last-12-hours' | 'last-24-hours' | 'custom';
type Type = 'thing' | 'person';

interface HistoryLinkProps {
  entity: string;
  type: Type;
  range: Range;
  start?: string;
  end?: string;
}

const toUrlSafeBase64 = (value: string): string => {
  return btoa(value)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/g, '');
};

export const historyLink: Operator<string> = (props): Nullable<string> => {
  const { entity, type, range } = props as unknown as HistoryLinkProps;
  let { start, end } = props as unknown as HistoryLinkProps;

  if (!entity || !type || !range) {
    return null;
  }

  const now = DateTime.now();

  switch (range) {
    case 'today':
      start = now.startOf('day').toISO();
      end = now.endOf('day').toISO();
      break;
    case 'yesterday':
      start = now.minus({ days: 1 }).startOf('day').toISO();
      end = now.minus({ days: 1 }).endOf('day').toISO();
      break;
    case 'last-12-hours':
      start = now.minus({ hours: 12 }).toISO();
      end = now.toISO();
      break;
    case 'last-24-hours':
      start = now.minus({ hours: 24 }).toISO();
      end = now.toISO();
      break;
    case 'custom':
      if (!start || !end) {
        return null;
      }
      break;
    default:
      return null;
  }

  if (!start || !end) {
    return null;
  }

  const historyData = {
    entities: [
      {
        _id: entity,
        type,
        journeys: [
          {
            start,
            finish: end,
          },
        ],
      },
    ],
  };

  const encodedData = toUrlSafeBase64(JSON.stringify(historyData));
  return generatePath('/history/:data', { data: encodedData });
};
